import client from '@/config/directus.api';

const COLLECTION = 'w2p_news';

/**
 * Get news
 *
 */
export function getNews() {
  return client
    .getItems(COLLECTION, {
      fields: ['*', 'created_by.*'],
      sort: '-publish_date'
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get news by id
 *
 * @param {int} id
 */
export function getNewsById(id) {
  return client
    .getItems(COLLECTION, {
      // fields: ['*', 'created_by.*'],
      // filter: {
      //     id
      // }
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}
